<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ 'Doc::Options' | abpLocalization }}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    @if (canCreateVersion()) {
      <div class="row p-2">
        <div class="form-check col-md-6">
          <input
            class="form-check-input"
            type="radio"
            role="checkbox"
            id="createCopy"
            formControlName="createVersion"
            [value]="false"
          />
          <label for="createCopy" class="form-check-label">
            {{ 'Doc::Duplicate' | abpLocalization }}
          </label>
        </div>
        <div class="form-check col-md-6">
          <input
            class="form-check-input"
            type="radio"
            role="checkbox"
            id="createVersion"
            formControlName="createVersion"
            [value]="true"
          />
          <label for="createVersion" class="form-check-label">
            {{ 'Doc::CustomerQuote:CreateVersion' | abpLocalization }}
          </label>
        </div>
      </div>
    }

    <div class="row">
      <div class="col mb-3">
        <input
          class="me-2 form-check-input"
          type="checkbox"
          role="switch"
          id="reevaluateTariff"
          formControlName="reevaluateTariff"
        />
        <label for="reevaluateTariff" class="form-check-label text-primary">
          {{ 'Doc::ReevaluateTariff' | abpLocalization }}
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <input
          class="me-2 form-check-input"
          type="checkbox"
          role="switch"
          id="copyAnnexes"
          formControlName="copyAnnexes"
        />
        <label for="copyAnnexes" class="form-check-label text-primary">
          {{ 'Doc::WithAnnexes' | abpLocalization }}
        </label>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary ms-2" (click)="modal.close()">
    {{ 'ERP::Cancel' | abpLocalization }}
  </button>
  <button class="btn btn-primary ms-2" (click)="clone()">
    {{ 'Doc::Following' | abpLocalization }}
  </button>
</div>
